import { Button, FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useReadingGoals } from '../../lib/ctx/reading_goals'

import illo from './assets/flower-cards.webp'
import badge from '../../lib/assets/icons/fable-premium-lock-badge.webp'
import { showPlusUpsell } from '../../lib/utils'
import { useStatsTheme } from '../../theme/ctx'

export const ReadingGoalsCardLocked = () => {
  const period = useReadingGoals((s) => s.period)
  const theme = useStatsTheme((s) => s.theme)
  const isMonth = period === 'month'

  const handleOnClick = () => showPlusUpsell()

  // bg: '#082D23',

  const gradient = theme.id.includes('dark')
    ? 'linear-gradient(180deg, rgba(8,45,35,0) 11.25%, rgba(8,45,35,1) 75%)'
    : 'linear-gradient(180deg, rgba(247,244,238,0) 11.25%, rgba(247,244,238,1) 75%)'

  return (
    <FlexBox
      role="button"
      aria-label="show goal subscription upsell"
      className={css`
        position: relative;
        width: 100%;
        border-radius: 16px;
        gap: 16px;
        background-color: ${theme.colors.section.bg};
      `}
      onClick={handleOnClick}
      flexDirection="column"
      centerAll
    >
      <div
        className={css`
          margin: -12px 0 -50px;
          position: relative;
        `}
      >
        <img
          className={css`
            display: block;
            width: 100%;
            max-width: 244px;
            object-fit: contain;
          `}
          src={illo}
          alt="reading goals stats"
        />
        <img
          className={css`
            display: block;
            width: 29px;
            position: absolute;
            top: 8px;
            left: calc(67%);
            transform: translateX(-50%);
            z-index: 1;
          `}
          src={badge}
          alt="fable plus lock badge"
        />
        <span
          className={css`
            display: block;
            position: absolute;
            bottom: 10px;
            left: 0;
            width: 100%;
            height: 60%;
            background: ${gradient};
          `}
        />
      </div>
      <FlexBox
        className={css`
          width: 100%;
          gap: 5px;
          position: relative;
          z-index: 1;
        `}
        flexDirection="column"
        alignItems="center"
      >
        <Text
          tag="h4"
          type="subhead"
          className={css`
            font-size: 14px;
            line-height: 16px;
            letter-spacing: -0.2px;
          `}
          weight="600"
          color={theme.colors.section.text}
          align="center"
        >
          Unlock {isMonth ? 'monthly' : 'weekly'} goals
        </Text>
        <Text
          type="body"
          className={css`
            width: 100%;
            max-width: 270px;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: -0.2px;
          `}
          weight="500"
          color={theme.colors.section.textSecondary}
          align="center"
        >
          {isMonth
            ? 'Keep yourself on track by breaking your annual goals into smaller, manageable steps.'
            : 'Track what truly motivates you by setting weekly targets for pages, days, or books read.'}
        </Text>
        <Button
          className={css`
            margin-top: 16px;
            padding: 0 20px;
            width: auto;
            height: 40px;
            font-size: 12px;
            line-height: 12px;
            background-color: ${theme.colors.upsellBtnBg};
            border-color: ${theme.colors.upsellBtnBg};
            color: ${theme.colors.upsellBtnText};
            &:hover {
              background-color: ${theme.colors.upsellBtnBg};
              border-color: ${theme.colors.upsellBtnBg};
              color: ${theme.colors.upsellBtnText};
            }
          `}
        >
          Try Fable Plus
        </Button>
      </FlexBox>
    </FlexBox>
  )
}
